/**
 * 모듈 공통 열거형 — 명세서 §5
 */
/** 발행 상태 — 알림장(§5.3)·공지(§5.4)·앨범(§5.5) 공통 */
export const PUBLISH_STATUS = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    PUBLISHED: 'PUBLISHED',
};
/** 알림장 작성 대상 (§5.3) */
export const NOTE_TARGET = {
    CLASS: 'CLASS',
    CHILD: 'CHILD',
};
/** 알림장 사진 최대 장수 (§5.3) */
export const DAILY_NOTE_MAX_PHOTOS = 10;
/** 공지 대상 (§5.4) */
export const NOTICE_AUDIENCE = {
    ALL: 'ALL',
    CLASS: 'CLASS',
    CHILD: 'CHILD',
};
/** 출석 상태 (§5.8) */
export const ATTENDANCE_STATUS = {
    EXPECTED: 'EXPECTED',
    PRESENT: 'PRESENT',
    LATE: 'LATE',
    ABSENT: 'ABSENT',
    EARLY_LEAVE: 'EARLY_LEAVE',
};
export const ATTENDANCE_STATUS_LABELS = {
    EXPECTED: '등원 예정',
    PRESENT: '등원',
    LATE: '지각',
    ABSENT: '결석',
    EARLY_LEAVE: '조퇴',
};
/** 편성 상태 (§5.2 진급/퇴소 이력 보존) */
export const ENROLLMENT_STATUS = {
    ENROLLED: 'ENROLLED',
    GRADUATED: 'GRADUATED',
    WITHDRAWN: 'WITHDRAWN',
    TRANSFERRED: 'TRANSFERRED',
};
/** 생활기록부 상태 (§5.13) */
export const LIFE_RECORD_STATUS = {
    DRAFT: 'DRAFT',
    APPROVED: 'APPROVED',
    ISSUED: 'ISSUED',
};
/**
 * 생활기록부 섹션 — P1 기본형 → P2·P3·P4 단계 확장 (§5.13).
 * PDF 서식은 섹션이 늘어나도 하위 호환을 유지하며, 빈 섹션은 출력하지 않는다.
 */
export const LIFE_RECORD_SECTIONS = {
    BASIC: 'BASIC',
    ATTENDANCE: 'ATTENDANCE',
    REMARKS: 'REMARKS',
    TEACHER_COMMENT: 'TEACHER_COMMENT',
    GROWTH: 'GROWTH',
    DEVELOPMENT: 'DEVELOPMENT',
    COUNSELING: 'COUNSELING',
};
export const LIFE_RECORD_SECTION_META = {
    BASIC: { label: '기본정보', phase: 'P1', order: 1 },
    ATTENDANCE: { label: '출결 현황', phase: 'P1', order: 2 },
    GROWTH: { label: '신체 성장', phase: 'P2', order: 3 },
    DEVELOPMENT: { label: '발달 기록', phase: 'P3', order: 4 },
    COUNSELING: { label: '부모면담 요약', phase: 'P4', order: 5 },
    REMARKS: { label: '특이사항', phase: 'P1', order: 6 },
    TEACHER_COMMENT: { label: '담임 종합의견', phase: 'P1', order: 7 },
};
/** 초대코드 (§4 초대코드 온보딩) */
export const INVITE_CODE_LENGTH = 8;
export const INVITE_CODE_DEFAULT_TTL_DAYS = 30;
/** 감사 로그 액션 (§9.1) */
export const AUDIT_ACTIONS = {
    CHILD_PROFILE_VIEW: 'CHILD_PROFILE_VIEW',
    DEVELOPMENT_RECORD_VIEW: 'DEVELOPMENT_RECORD_VIEW',
    LIFE_RECORD_VIEW: 'LIFE_RECORD_VIEW',
    LIFE_RECORD_DOWNLOAD: 'LIFE_RECORD_DOWNLOAD',
    PHOTO_DOWNLOAD: 'PHOTO_DOWNLOAD',
    DOCUMENT_VIEW: 'DOCUMENT_VIEW',
    DOCUMENT_DOWNLOAD: 'DOCUMENT_DOWNLOAD',
    CHILD_WITHDRAW: 'CHILD_WITHDRAW',
    SUBSCRIPTION_APPROVE: 'SUBSCRIPTION_APPROVE',
    FACILITY_APPROVE: 'FACILITY_APPROVE',
    PHOTO_POLICY_CHANGE: 'PHOTO_POLICY_CHANGE',
};
/** 기록 보존 — 퇴소 후 5년 (§9.1, §14.1-14) */
export const RETENTION_YEARS_AFTER_EXIT = 5;
/** 체온 임계값 기본값 (§5.11) — 시설 설정으로 조정 */
export const TEMPERATURE_ALERT_THRESHOLD = 37.5;
/**
 * 육아상담 챗봇 응급 징후 키워드 (§5.16 가드레일).
 * 하나라도 걸리면 모델을 부르지 않고 119·응급실 안내 고정 응답을 먼저 낸다.
 */
export const CHAT_EMERGENCY_KEYWORDS = [
    '경련',
    '발작',
    '호흡곤란',
    '숨을 못',
    '숨을 안',
    '숨쉬기 힘들',
    '의식이 없',
    '의식을 잃',
    '축 늘어',
    '늘어져',
    '청색증',
    '파랗게 질리',
    '입술이 파랗',
    '40도',
    '피를 토',
    '혈변',
    '머리를 부딪',
    '삼켰어',
    '삼킴',
    '중독',
];
/** 쪽지 응대 시간 기본값 (§5.18) — 시설 설정(settings.replyHours)으로 덮어쓴다 */
export const MESSAGE_REPLY_HOURS_DEFAULT = {
    start: '09:00',
    end: '18:00',
    weekdaysOnly: true,
};
/** 부모면담 상태 (§5.15) */
export const COUNSELING_STATUS_LABELS = {
    REQUESTED: '신청됨',
    CONFIRMED: '확정',
    DONE: '면담 완료',
    CANCELED: '취소',
};
/** 버스 실시간 위치 (§5.20 P6) — 정거장 도착 임박 판정 반경(m)과 위치 송출 주기(ms) */
export const BUS_LIVE = {
    approachRadiusM: 300,
    locationIntervalMs: 10_000,
};
/**
 * 두 좌표 사이 거리(m) — 하버사인. 정거장 도착 임박 판정에 쓴다(§5.20 P6).
 * 수백 m 수준 판정이라 지구 반지름 구면 근사로 충분하다.
 */
export function distanceMeters(lat1, lng1, lat2, lng2) {
    const R = 6_371_000;
    const rad = (deg) => (deg * Math.PI) / 180;
    const dLat = rad(lat2 - lat1);
    const dLng = rad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
}
/** 원 운영 도구 (P6) — 식자재 검수 결과 */
export const FOOD_INSPECTION_RESULTS = ['PASS', 'FAIL'];
export const FOOD_INSPECTION_RESULT_LABELS = {
    PASS: '합격',
    FAIL: '반품·폐기',
};
/** 원 운영 도구 (P6) — 교직원 근태 상태 */
export const STAFF_ATTENDANCE_STATUSES = ['WORK', 'LEAVE', 'HALF', 'SICK', 'ABSENT'];
export const STAFF_ATTENDANCE_STATUS_LABELS = {
    WORK: '근무',
    LEAVE: '연차',
    HALF: '반차',
    SICK: '병가',
    ABSENT: '결근',
};
/** 입소 대기 상태 (P5) */
export const WAITLIST_STATUSES = ['WAITING', 'OFFERED', 'ENROLLED', 'CANCELED'];
export const WAITLIST_STATUS_LABELS = {
    WAITING: '대기 중',
    OFFERED: '입소 안내',
    ENROLLED: '입소 완료',
    CANCELED: '대기 취소',
};
/** AI 사용 한도 (§5.16, §5.23) */
export const AI_QUOTAS = {
    /** 학부모 육아상담 1일 질문 횟수 (§14.1-7) */
    parentChatPerDay: 10,
    /** 교사 글쓰기 도우미 1일 사용 횟수 (§5.23) */
    teacherWritingPerDay: 30,
};
//# sourceMappingURL=domain.js.map